import { useEffect } from 'react';

export const EnvironmentThemeHandler = (): null => {
    useEffect(() => {
        const hostname = window.location.hostname;
        const documentElement = document.documentElement;

        // Remove existing env attributes first to be safe
        documentElement.removeAttribute('data-env');

        // Detect environment
        if (
            hostname.includes('acc.clando.app') ||
            hostname.includes('clando.vercel.app')
        ) {
            documentElement.setAttribute('data-env', 'acceptance');
        } else if (
            hostname.includes('localhost') ||
            hostname.includes('127.0.0.1')
        ) {
            documentElement.setAttribute('data-env', 'development');
        } else {
            // Production - explicit or default
            documentElement.setAttribute('data-env', 'production');
        }
    }, []);

    return null;
};
